exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-ea95e1a8]{margin-top:40px}", ""]);

// exports
